export default {"src":"/_next/static/image/public/images/ic_flash_shipment.01424bca736daac745b2dccc8c9d2785.svg","height":40,"width":53};